// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3WGUH","range":"MonthRangeSwitch_range__3h9CT","disabled":"MonthRangeSwitch_disabled__2PS4z"};